import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { isErrorResponse } from "./guards";
import { ErrorResponse } from "./queriesApi.generated.ts";

const somethingWentWrong = "Coś poszło nie tak";

export const extractApiErrorUnknown = (error: unknown) => {
  if (error && typeof error === "object") {
    return extractApiError(error);
  } else {
    return somethingWentWrong;
  }
};

const extractApiErrorErrorResponse = (errorData: ErrorResponse) => {
  const { detail } = errorData;
  if (typeof detail === "string") {
    return detail;
  }
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((valError) => valError.msg).join(", ");
  }
};

export const extractApiError = (
  error: FetchBaseQueryError | SerializedError,
): string => {
  if ("data" in error && isErrorResponse(error.data)) {
    switch (error.data.error_code) {
      case "validation_error":
        return "Błąd walidacji";
      case "duplicate":
        return "Duplikat";
      case "not_found":
        return "Nie znaleziono";
      case "expired_token":
        return "Wygasł token";
      case "invalid_token":
        return "Nieprawidłowy token";
      case "invalid_user":
        return "Nieprawidłowy użytkownik";
      case "invalid_user_organization":
        return "Nieprawidłowa organizacja użytkownika";
      case "invalid_in_filter":
        return `Nieprawidłowy filtr ${extractApiErrorErrorResponse(error.data)}`;
      case "invalid_search_fields":
        return `Nieprawidłowe pola wyszukiwania ${extractApiErrorErrorResponse(error.data)}`;
      case "invalid_order_by":
        return `Nieprawidłowy sortowanie ${extractApiErrorErrorResponse(error.data)}`;
      case "invalid_related_company":
        return "Nieprawidłowa firma";
      case "invalid_related_driver":
        return "Nieprawidłowy kierowca";
      case "invalid_related_vehicle":
        return "Nieprawidłowy pojazd";
      case "invalid_related_product":
        return "Nieprawidłowy produkt";
      case "invalid_related_location":
        return "Nieprawidłowy lokalizacja";
      default:
        return typeof error.data.detail === "string"
          ? error.data.detail
          : somethingWentWrong;
    }
  }
  if ("status" in error && typeof error.status === "number") {
    return `Błąd serwera (${error.status})`;
  }
  return somethingWentWrong;
};
